// src/pages/Creators.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Box,
  Button,
  IconButton,
  Chip
} from '@mui/material';
import { motion } from 'framer-motion';
import {
  Instagram,
  Twitter,
  YouTube,
  SportsEsports
} from '@mui/icons-material';

import ParticleBackground from '../components/common/ParticleBackground';

const creatorsData = [
  {
    id: 1,
    name: 'Kime',
    image: 'https://via.placeholder.com/300',
    instagram: 'https://instagram.com/kimeflow',
    twitter: 'https://twitter.com/',
    youtube: 'https://youtube.com/',
    twitch: 'https://twitch.tv/kime27',
    kick: 'https://kick.com/kime27',
    isLive: true
  },
  {
    id: 2,
    name: 'Rodrii1560',
    image: 'https://via.placeholder.com/300',
    instagram: 'https://instagram.com/',
    twitter: 'https://twitter.com/',
    youtube: 'https://youtube.com/',
    twitch: 'https://twitch.tv/',
    kick: 'https://kick.com/',
    isLive: false
  },
    {
    id: 3,
    name: 'grone',
    image: 'https://via.placeholder.com/300',
    instagram: 'https://instagram.com/',
    twitter: 'https://twitter.com/',
    youtube: 'https://youtube.com/',
    twitch: 'https://twitch.tv/',
    kick: 'https://kick.com/',
    isLive: true
  }, 
    {
  id: 4,
    name: 'german',
    image: 'https://via.placeholder.com/300',
    instagram: 'https://instagram.com/',
    twitter: 'https://twitter.com/',
    youtube: 'https://youtube.com/',
    twitch: 'https://twitch.tv/',
    kick: 'https://kick.com/',
    isLive: true
  }, 

   {
    id: 5,
    name: 'Onix',
    image: 'https://via.placeholder.com/300',
    instagram: 'https://instagram.com/',
    twitter: 'https://twitter.com/',
    youtube: 'https://youtube.com/',
    twitch: 'https://twitch.tv/',
    kick: 'https://kick.com/',
    isLive: true
  }, 

   {
    id: 6,
    name: 'RebelFox',
    image: 'https://via.placeholder.com/300',
    instagram: 'https://instagram.com/',
    twitter: 'https://twitter.com/',
    youtube: 'https://youtube.com/',
    twitch: 'https://twitch.tv/',
    kick: 'https://kick.com/',
    isLive: true
  }, 


];

const Creators = () => {
  const [clicks, setClicks] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem('creatorClicks');
    if (stored) setClicks(JSON.parse(stored));
  }, []);

  const handleClick = (id) => {
    const updated = {
      ...clicks,
      [id]: (clicks[id] || 0) + 1
    };
    setClicks(updated);
    localStorage.setItem('creatorClicks', JSON.stringify(updated));
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        background: 'linear-gradient(180deg, #0a0a0a 0%, #1a0a05 100%)',
        overflow: 'hidden'
      }}
    >
      <ParticleBackground />

      <Container sx={{ position: 'relative', zIndex: 2, py: 10 }}>
        
        {/* TITLE */}
        <Typography
          variant="h2"
          align="center"
          sx={{
            color: '#fff',
            mb: 6,
            textShadow: '0 0 20px rgba(255,110,0,0.6)'
          }}
        >
          Creadores Rebel Fox
        </Typography>

        <Grid container spacing={4}>
          {creatorsData.map((creator) => (
            <Grid item xs={12} sm={6} md={4} key={creator.id}>
              
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <Box
                  sx={{
                    background: 'rgba(0,0,0,0.7)',
                    borderRadius: 3,
                    p: 3,
                    textAlign: 'center',
                    boxShadow: '0 0 25px rgba(255,110,0,0.3)',
                    backdropFilter: 'blur(10px)',
                    position: 'relative'
                  }}
                >
                  
                  {/* STATUS */}
                  <Chip
                    label={creator.isLive ? 'EN VIVO' : 'OFFLINE'}
                    sx={{
                      position: 'absolute',
                      top: 10,
                      right: 10,
                      backgroundColor: creator.isLive ? 'green' : 'red',
                      color: '#fff',
                      fontWeight: 'bold'
                    }}
                  />

                  {/* IMAGE */}
                  <Box
                    component="img"
                    src={creator.image}
                    sx={{
                      width: '100%',
                      height: 200,
                      objectFit: 'cover',
                      borderRadius: 2,
                      mb: 2
                    }}
                  />

                  {/* NAME */}
                  <Typography variant="h5" sx={{ color: '#fff', mb: 2 }}>
                    {creator.name}
                  </Typography>

                  {/* SOCIALS */}
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                    
                    <IconButton
                      href={creator.instagram}
                      target="_blank"
                      onClick={() => handleClick(creator.id)}
                      sx={{ color: '#ff6e00' }}
                    >
                      <Instagram />
                    </IconButton>

                    <IconButton
                      href={creator.twitter}
                      target="_blank"
                      onClick={() => handleClick(creator.id)}
                      sx={{ color: '#ff6e00' }}
                    >
                      <Twitter />
                    </IconButton>

                    <IconButton
                      href={creator.youtube}
                      target="_blank"
                      onClick={() => handleClick(creator.id)}
                      sx={{ color: '#ff6e00' }}
                    >
                      <YouTube />
                    </IconButton>

                    <IconButton
                      href={creator.twitch}
                      target="_blank"
                      onClick={() => handleClick(creator.id)}
                      sx={{ color: '#9146FF' }}
                    >
                      <SportsEsports />
                    </IconButton>

                  </Box>

                  {/* KICK BUTTON */}
                  <Button
                    href={creator.kick}
                    target="_blank"
                    onClick={() => handleClick(creator.id)}
                    sx={{
                      mt: 2,
                      color: '#00ff99',
                      border: '1px solid #00ff99',
                      '&:hover': {
                        background: '#00ff99',
                        color: '#000'
                      }
                    }}
                  >
                    Ver en Kick
                  </Button>

                  {/* CLICK COUNTER */}
                  <Typography
                    variant="body2"
                    sx={{ mt: 2, color: '#aaa' }}
                  >
                    Clicks: {clicks[creator.id] || 0}
                  </Typography>

                </Box>
              </motion.div>

            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Creators;